import { gql } from '@apollo/client';

export const getHomeBanner = gql`
    {
        getHomeBanner {
            id
            name
        }
    }
`;

export const addHomeBanner = gql`
    mutation addHomeBanner($name: String!){
        addHomeBanner(name: $name) {
            status
        }
    }
    `;

export const deleteHomeBanner = gql`
    mutation deleteHomeBanner ($id: Int!) {
      deleteHomeBanner (id: $id) {
          status
        }
      }
    `;

export const getImageBanner = gql`
    {
        getImageBanner {
            id
            title
            description
            buttonLabel
            image
        }
    }
    `;

export const updateImageBannerMutation = gql`
    mutation updateImageBanner(
        $title: String!,
        $description: String!,
        $buttonLabel: String!){
        updateImageBanner(
            title: $title,
            description: $description,
            buttonLabel: $buttonLabel
        ) {
            status
        }
    }
    `;

export const uploadImageBannerMutation = gql`
    mutation uploadImageBanner($image: String!){
        uploadImageBanner(image: $image) {
            status
        }
    }
    `;

export const updateStaticPage = gql`
    mutation updateStaticPage(
      $id: Int,
      $content: String,
      $metaTitle: String,
      $metaDescription: String,
    ) {
      updateStaticPage(
        id: $id,
        content: $content,
        metaTitle: $metaTitle,
        metaDescription: $metaDescription,
      ) {
          status
      }
    }
    `;

export const getEditStaticPage = gql`query getEditStaticPage ($id: Int!) {
    getEditStaticPage (id: $id) {
        id
        pageName
        content
        metaTitle
        metaDescription
        createdAt
    }
  }`;

export const getHomeBannerQuery = gql`
query ($userType: String) {
    getHomeBanner(userType: $userType) {
        id
        name
    }
}
`;

export const getAllStaticPage = gql`query getAllStaticPage {
    getAllStaticPage{
        results {
             id
             pageName
             content
             metaTitle
             metaDescription
             createdAt
             isEnable
        }
    }
  }`;

export const updateStaticPageStatus = gql`
  mutation updateStaticPageStatus ($id: Int, $isEnable: Boolean){
    updateStaticPageStatus(id: $id, isEnable: $isEnable){
          status
          errorMessage
      }
  }
`;


export const updateStaticBlockSettings = `mutation (
      $headerTitle: String,
      $headerContent: String,
      $blockTitle1: String,
      $blockContent1: String,
      $blockTitle2: String,
      $blockContent2: String,
      $blockImage1: String,
      $blockImage2: String,
      $isEnable: String
    ) {
      updateStaticBlockSettings (
        headerTitle: $headerTitle,
        headerContent: $headerContent,
        blockTitle1: $blockTitle1,
        blockContent1: $blockContent1,
        blockTitle2: $blockTitle2,
        blockContent2: $blockContent2,
        blockImage1: $blockImage1,
        blockImage2: $blockImage2,
        isEnable: $isEnable
      ) {
          status
      }
    }`;

export const createFooterSetting = `mutation (
      $title1: String,
      $content1: String,
      $title2: String,
      $content2: String,
      $title3: String,
      $content3: String,
    ) {

      CreateFooterSetting (
        title1: $title1,
        content1: $content1,
        title2: $title2,
        content2: $content2,
        title3: $title3,
        content3: $content3,
      ) {
          status
      }
    }`;